import { render, staticRenderFns } from "./derives-size.vue?vue&type=template&id=358b28d7&scoped=true"
import script from "./derives-size.vue?vue&type=script&lang=js"
export * from "./derives-size.vue?vue&type=script&lang=js"
import style0 from "./derives-size.vue?vue&type=style&index=0&id=358b28d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358b28d7",
  null
  
)

export default component.exports